module.exports = __webpack_public_path__ + "media/images/flags/64/Kosovo-fb70277fcb9e0b0cb501873813713647.png";